import React from 'react';
import { Link } from 'react-router-dom';
import { LOCATIONS } from '../data/site';
import { PHOTO, COLLATERAL, TEXTURE } from '../data/media';
import Reveal from './Reveal';
import TapeLabel from './TapeLabel';
import { ArrowRight } from './Icons';
import './Locations.css';

/* Matches the original: hand-lettered branch names (orange marker + pin SVGs)
   paired with a dish photo each, staggered over the giant faint motif. */

const IMAGES = {
  bugolobi: PHOTO.plate5,
  kyanja: PHOTO.plate8,
};

const LETTERING = {
  bugolobi: COLLATERAL.bugolobiLettering,
  kyanja: COLLATERAL.kyanjaLettering,
};

export default function Locations({ heading = true, className = '' }) {
  return (
    <section className={`section locations${className ? ` ${className}` : ''}`} id="locations">
      <img className="locations__motif" src={TEXTURE.motif} alt="" aria-hidden="true" loading="lazy" />

      <div className="page stack stack-lg locations__inner">
        {heading ? <TapeLabel>Our locations</TapeLabel> : null}

        <div className="locations__grid">
          {LOCATIONS.map((loc, i) => (
            <Reveal className={`loc loc--${loc.id}`} key={loc.id} delay={i * 0.12}>
              <img
                className="loc__lettering"
                src={LETTERING[loc.id]}
                alt={`The Local ${loc.name}`}
                loading="lazy"
              />

              <div className="frame frame--3x4 frame--hover loc__media">
                <img src={IMAGES[loc.id]} alt={`A dish at The Local ${loc.name}`} loading="lazy" />
              </div>

              <div className="loc__actions">
                <a className="link" href={loc.mapUrl} target="_blank" rel="noopener noreferrer">
                  Get location <ArrowRight />
                </a>
                <Link className="link" to={`/locations/${loc.id}`}>
                  About this branch <ArrowRight />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
